module.exports = __webpack_public_path__ + "img/potencia_c.ef517687.svg";